var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_616_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3176 39.228L13.9697 15.9778C13.3144 15.2291 12.1762 15.1533 11.4274 15.8086L11.2543 15.9601C10.5056 16.6154 10.4298 17.7536 11.0851 18.5024L31.433 41.7525C32.0883 42.5013 33.2265 42.5771 33.9753 41.9218L34.1483 41.7703C34.8971 41.115 34.9729 39.9768 34.3176 39.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4322 15.9775L11.0849 39.2282C10.4297 39.977 10.5055 41.1152 11.2542 41.7705L11.4273 41.922C12.1761 42.5772 13.3144 42.5014 13.9696 41.7526L34.3169 18.502C34.9722 17.7532 34.8964 16.615 34.1476 15.9597L33.9745 15.8082C33.2257 15.1529 32.0875 15.2287 31.4322 15.9775Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_616_329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.e757ce31e8d5f7399cf3cb00731afa92.svg";
export { ForwardRef as ReactComponent };